var React = require('react');

function ChartNocheckInline (props) {
    return React.createElement("g",props,React.createElement("path",{"d":"M8.273438,17.374023l-1.646973-1.647461L10.353027,12L6.626465,8.273438l1.646973-1.646973L12,10.353027l3.726562-3.726562\n\t\tl1.647461,1.646973L13.647461,12l3.726562,3.726562l-1.647461,1.647461L12,13.647461L8.273438,17.374023z"}));
}

ChartNocheckInline.defaultProps = {};

module.exports = ChartNocheckInline;

ChartNocheckInline.default = ChartNocheckInline;
